import type {
  UseInterventionFollowupProps,
  InterventionFollowupVariables,
  InterventionCreatePayload,
} from "./intervention.type";
import type { ApiError } from "@/services/api";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useInterventionFollowup = ({
  id,
  invalidateKeys,
  onSuccess,
  ...options
}: UseInterventionFollowupProps) => {
  const mutationFn = (variables: InterventionFollowupVariables) => {
    return client.interventions.followup(id, variables);
  };
  const queryClient = useQueryClient();

  const onMutationSuccess = (payload: InterventionCreatePayload) => {
    onSuccess?.(payload.data.data);

    invalidateKeys?.forEach((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    );
  };

  return useMutation<
    InterventionCreatePayload,
    ApiError,
    InterventionFollowupVariables
  >({
    mutationFn,
    onSuccess: onMutationSuccess,
    ...options,
  });
};
